import React from 'react';

interface FeeInputsProps {
  fees: Record<string, {
    fixedFee: number | '';
    percentageFee: number | '';
    maxCap: number | '';
  }>;
  disabled: boolean;
  onChange: (fees: typeof FeeInputsProps['fees']) => void;
}

export function FeeInputs({ fees, disabled, onChange }: FeeInputsProps) {
  const updateFee = (status: string, field: keyof typeof fees[string], value: string) => {
    const numericValue = value === '' ? '' : parseFloat(value);
    onChange({
      ...fees,
      [status]: {
        ...fees[status],
        [field]: numericValue
      }
    });
  };

  return (
    <>
      {['approved', 'declined', 'returned'].map((status) => (
        <div key={status} className="mb-6">
          <h5 className="text-sm font-medium text-gray-700 mb-3 capitalize">
            {status} Status
          </h5>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Fixed Fee Per Transaction
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-gray-500 sm:text-sm">$</span>
              </div>
              <input
                type="number"
                min="0"
                step="0.01"
                value={fees[status].fixedFee === '' ? '' : fees[status].fixedFee}
                onChange={(e) => updateFee(status, 'fixedFee', e.target.value)}
                disabled={disabled}
                className="block w-full"
              />
            </div>
            <label className="block text-sm font-medium text-gray-700 mt-4">
              Percentage Fee
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <input
                type="number"
                min="0"
                step="0.001"
                max="100"
                value={fees[status].percentageFee === '' ? '' : fees[status].percentageFee}
                onChange={(e) => updateFee(status, 'percentageFee', e.target.value)}
                disabled={disabled}
                className="block w-full"
              />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <span className="text-gray-500 sm:text-sm">%</span>
              </div>
            </div>
            <label className="block text-sm font-medium text-gray-700 mt-4">
              Maximum Fee Cap
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-gray-500 sm:text-sm">$</span>
              </div>
              <input
                type="number"
                min="0"
                step="0.01"
                value={fees[status].maxCap === '' ? '' : fees[status].maxCap}
                onChange={(e) => updateFee(status, 'maxCap', e.target.value)}
                disabled={disabled}
                className="block w-full"
              />
            </div>
          </div>
        </div>
      ))}
    </>
  );
}